<template>
  <div class="overflow-auto steps-fix">
    <b-container v-if="!eventState">
      <Head @start="firstStep()" :currentPage="currentPage"></Head>
      <div>
        <b-row class="mb-5">
          <b-col class="canvas-container-position">
            <div class="slogan">
                <div class="slogan-inner">
                  <img class="slogan-logo" src="~@/assets/imgs/welcome-to-real.svg" />
                </div>
            </div>
            <ItemizerCanvas
              v-if="this.event"
              :event="this.event"
              :currentPage="this.currentPage"
              ref="canvas"
            ></ItemizerCanvas>
          </b-col>
        </b-row>
        <div class="ready" v-if="currentPage == 4">
          <h2>OKAY, BIS GLEICH</h2>

          <h5>Deine Abholnummer:</h5>

          <p class="delivery-id">{{ deliveryId }}</p>
        </div>
        <div class="button-container"  v-if="currentPage == 1">
            <div class="inner">
              <b-button v-b-modal.modal-text variant="secondary"
                >Mein Text</b-button
              >
              <b-button v-b-modal.modal-icons variant="secondary"
                >Meine Icons</b-button
              >
            </div>
        </div>


        <div v-if="currentPage == 1" class="next-step-container">
            <b-button variant="secondary" class="outline" v-on:click="exportToPngAndContinue"
              >Vorschau</b-button
            >
        </div>

        <div class="button-container"  v-if="currentPage == 2">
          <div class="inner">
            <b-button class="outline" variant="secondary" v-on:click="goToStep(1)"
              >Da fehlt was</b-button
            >
            <b-button variant="secondary" v-on:click="nextStep()"
                >Genau so!</b-button
              >
          </div>
        </div>
      </div>

      <div id="stepView3" v-if="currentPage == 3">

        <b-form @submit="submitDesign" class="form-narrow mx-auto">
          <h3 class="font-label">Für die Abholung brauchen wir Deinen Namen</h3>
          <mdb-input
            id="firstName"
            v-model.trim="firstName"
            type="text"
            name="first_name"
            class="first_name"
            required
          ></mdb-input>


          <b-row class="justify-content-center">
            <b-col cols="auto">
              <b-button
                type="submit"
                variant="secondary"
                class="mb-4"
                :disabled="isLoading == true"
              >
                <b-spinner
                  class="mr-2 mb-1"
                  v-show="isLoading"
                  small
                ></b-spinner>
                {{ formSubmitButtonText }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </b-container>
    <div v-else>
      <b-container
        class="container-narrow"
      >{{ event_inactive_message.value }}</b-container>
    </div>
    <Steps @start="firstStep()" :currentPage="currentPage"></Steps>
  </div>
</template>

<script>
import axios from "axios";
import Auth from '../services/auth.service';
import sanitize from "sanitize-filename";
import ItemizerCanvas from "./ItemizerCanvas.vue";
import { mdbInput } from "mdbvue";
import Head from './Head.vue';
import Steps from './Steps.vue';

export default {
  components: {
    ItemizerCanvas,
    mdbInput,
    Head,
    Steps
  },
  props: {
    event: String,
  },
  data() {
    return {
      deliveryId: 'AB123',
      rows: 4,
      perPage: 1,
      currentPage: 1,
      canvas: {},
      firstName: "",
      lastName: "",
      email: "",
      street: "",
      houseNumber: "",
      postcode: "",
      city: "",
      phone: "",
      isLoading: false,
      authToken: "",
      eventData: this.event,
      eventState: null,
      event_inactive_message: null,
      customer_id: null,
      placesAddress: null,
      googleMapsApiKey: "AIzaSyACLj6YzOV3_Xc_FnfcPxGFvEYZakOyL3w",
      googleMapsScriptLoaded: false,
      id: "",
    };
  },
  computed: {
    formSubmitButtonText: function () {
      if (this.isLoading == true) {
        return "Sendet...";
      }
      return "Und los!";
    },
  },
  mounted: function () {
    this.canvas = this.$refs.canvas;
    this.initAuthentication();
    const url = this.$apiBaseUrl + `/api/v1/events/${this.eventData}`;
    let self = this;
    axios.get(url).then((res) => {
      self.eventState = res.data.data.attributes.field_event_state;
      self.event_inactive_message =
        res.data.data.attributes.field_event_inactive_message;
      self.id = res.data.data.relationships.field_item_types.data.filter(item => item.item_type.includes('lighter'))[0].id;
    });
    this.customer_id = new URL(location.href).searchParams.get("customer_id");
  },
  methods: {
    goToStep(step) {
      this.currentPage = step;
    },
    firstStep() {
      this.$emit('start')
    },
    exportToPngAndContinue() {
      this.canvas.exportToPng();
      this.nextStep();
    },
    initAuthentication() {
      let self = this;
      Auth.authorize().then((r) => {
        self.authToken = r.accessToken;
      })
    },
    nextStep() {
      this.currentPage++;
    },
    submitDesign(e) {
      e.preventDefault();
      this.isLoading = true;
      let self = this;
      this.canvas.getBlobFromCanvas('black').then(function (blob) {
        self.sendDataAndContinue(blob);
      });
    },
    sendDataAndContinue(userDesignBlob) {
      let self = this;
      const userData = {
        data: {
          type: "node--item",
          attributes: {
            title: "My custom title",
            body: {
              value: "Customer item",
              format: "plain_text",
            },
            field_customer_id: this.customer_id,
            address: {
              langcode: "",
              country_code: "DE",
              administrative_area: null,
              locality: this.city,
              dependent_locality: null,
              postal_code: this.postcode,
              sorting_code: null,
              address_line1: this.street,
              address_line2: this.houseNumber,
              organization: null,
              given_name: this.firstName,
              additional_name: null,
              family_name: this.lastName,
            },
            email: this.email,
            phone: this.phone,
          },
          relationships: {
            field_item_type: {
              data: {
                type: "taxonomy_term--item_type",
                id: this.id,
              },
            },
            field_event: {
              data: {
                type: "node--event",
                id: this.eventData,
              },
            },
          },
        },
      };
      const url = `${self.$apiBaseUrl}/api/v1/items`;
      const options = {
        headers: {
          "Content-Type": "application/vnd.api+json",
        },
      };
      axios.defaults.headers.common = {
        Authorization: `Bearer ${self.authToken}`,
      };
      axios
        .post(url, userData, options)
        .then((res) => {
          return res.data.data;
        })
        .then((data) => {
          const id = data.id;
          // const nid = data.attributes.drupal_internal__nid;
          // Because it seems not possible with Axios right now to sent binary data with the required Header "Content-Type:" "application/octet-stream"
          // i am using vanilla AJAX to post the image. Not nice but it works. See the following axios issues to read about the bug:
          // https://github.com/axios/axios/issues/2623
          // https://github.com/axios/axios/issues/86


          this.deliveryId = this.firstName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().substring(0, 3) + data.attributes.drupal_internal__nid;

          axios.patch(`${self.$apiBaseUrl}/api/v1/items/${id}`, {
            data: {
              type: "node--item",
              id: id,
              attributes: {
                field_job_id: this.deliveryId
              }
            }
          },  {
            headers: {
              "Content-Type": "application/vnd.api+json",
            },
            }).then(() => {
              var xhr = new XMLHttpRequest();
              xhr.onreadystatechange = function () {
                console.log("this.readyState:", this.readyState);
                console.log("this.status:", this.status);
                if (this.readyState == 4 && this.status == 200) {
                  // document.getElementById("demo").innerHTML = this.responseText;
                  self.isLoading = false;
                  self.nextStep();
                } else {
                  if (this.readyState == 4 && this.status != 200) {
                    self.isLoading = false;
                    console.log(
                      `something went wrong. ajax state and status:  ${this.state} and ${this.status}`
                    );
                  }
                }
              };
              xhr.open(
                "POST",
                `${self.$apiBaseUrl}/api/v1/items/${id}/field_user_design`
              );
              xhr.setRequestHeader("Content-Type", "application/octet-stream");
              xhr.setRequestHeader(
                "Content-Disposition",
                `file; filename="${self.getFilename()}"`
              );
              xhr.setRequestHeader("Authorization", `Bearer ${self.authToken}`);
              xhr.send(userDesignBlob);
          }).catch(() => {
            self.isLoading = false;
            this.$emit('start');
          });
        });
    },
    getFilename() {
      let fileFirstname = this.firstName
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      let fileLastname = this.lastName
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      // (Sanitized and trimmed and spaces replaced by "_") <firstname>_<lastname>_<unixtimestamp>.png
      return `${sanitize(fileFirstname, "_")}_${sanitize(
        fileLastname,
        "_"
      )}_${new Date().getTime()}.png`
        .split(" ")
        .join("_");
    },
    resetCanvas() {
      this.canvas.resetCanvas();
      this.firstStep();
    },
  },
};
</script>
<style lang="scss" scoped>
.logo {
  margin: 29px;
}
.header-container {
  .logo-container {
    border-right: 1px solid black;
    margin-top: 30px;
  }
}

.button-container {
  max-width: 410px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;

  .inner {
    display: inline-block;

    button:first-child {
      margin-right: 70px;
    }

    button {
      width: 170px;
    }
  }
}

.next-step-container {
  max-width: 410px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  button {
    width: 100%;
  }
}

button.outline {
  background-color: white;
  color: #00A1E8;
}

.md-form input.form-control {
  border: 1px solid black !important;
  background-color: white !important;
  color: black;
}

.font-label {
  color: black;
  font-size: 16px;
  font-weight: normal;
}

.ready {
  text-align: center;
  color: black;

  h2 {
    font-size: 19px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  h5 {
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 10px;
  }

  p {
    font-size: 120px;
    line-height: 120px;
    margin-bottom: 0;
    padding: 0;
    font-weight: normal;
    letter-spacing: 12px;
  }
}

.canvas-container-position {
  position: relative;

  .slogan {
    max-width: 810px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    position: absolute;
    bottom: 0;
    display: inline-block;
    text-align: center;

    > div {
      text-align: left;
      display: inline-block;
      padding-left: 430px;

      > h2 {
        font-weight: normal;
        color: #2351A0;
        margin: 0;
        line-height: 28px;
        font-size: 31px;
      }
    }
  }
}

.steps-fix {
  padding-bottom: 135px;
}
</style>
